import { Environment } from './../app/models/envarioment'
import { environment as oaprProd } from './suport/oapr'
// import { environment as doneITProd } from './suport/doneIt'
import { DevDev } from './suport/dev'


export const environment: Environment = DevDev;
